import React from 'react'
import moment from 'moment'
import { List, useListRepository } from 'elentari'
import { useAbility } from '../../Usuarios'
import { getListActions } from '../../../lib/crudAuthorization'
import tarefaEmbarcadorRepository from './tarefaEmbarcadorRepository'
import { TarefaBadgeStatus } from '../TarefaStatus'
import TarefaEmbarcadorFilter from '../Filters/TarefaEmbarcadorFilter'
import { formatNomeUsuario } from '../../../utils/Formatter'

const TarefaEmbarcador = props => {
  const [ability] = useAbility()

  const listHook = useListRepository({
    repository: tarefaEmbarcadorRepository,
    path: 'tarefasEmbarcador',
    defaultSort: 'createdAt desc'
  })

  const listOptions = {
    defaultOrder: 'createdAt desc',
    fields: {
      id: {
        label: 'Id'
      },
      createdAt: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm'),
        align: 'center'
      },
      responsavel: {
        label: 'Responsável',
        format: formatNomeUsuario
      },
      ordemCarregamento: {
        label: 'Ordem de Carregamento'
      },
      cpfMotorista: {
        label: 'CPF'
      },
      placaCavalo: {
        label: 'Placa'
      },
      status: {
        label: 'Status',
        format: value => <TarefaBadgeStatus status={value} />
      },
      embarcador: {
        label: 'Embarcador',
        format: formatNomeUsuario,
        noOrder: true
      },
      dataTermino: {
        label: 'Data Término',
        format: data => (data ? moment(data).format('DD/MM/YYYY HH:mm') : '-'),
        align: 'center'
      },
      empresa: {
        label: 'Empresa',
        format: empresa => (empresa ? empresa.sigla : '-'),
        noOrder: true,
        align: 'center'
      }
    }
  }

  const actions = getListActions(ability, listHook, 'tarefasEmbarcador')

  return (
    <>
      <TarefaEmbarcadorFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        removeItem={null}
        onClickEdit={null}
        onClickRow={item => props.history.push(`/tarefasEmbarcador/${item.id}`)}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default TarefaEmbarcador
